import { useEffect, useRef } from 'react'
import { IconX } from '@tabler/icons-react'

const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'

export default function Drawer({ open, onClose, title, children, width = 400 }) {
  const panelRef = useRef(null)

  useEffect(() => {
    if (!open) return
    // Focus first focusable element inside drawer
    const first = panelRef.current?.querySelector(FOCUSABLE)
    if (first) first.focus()

    function trapFocus(e) {
      if (e.key !== 'Tab') return
      const els = Array.from(panelRef.current?.querySelectorAll(FOCUSABLE) || [])
      if (!els.length) return
      const first = els[0], last = els[els.length - 1]
      if (e.shiftKey ? document.activeElement === first : document.activeElement === last) {
        e.preventDefault()
        ;(e.shiftKey ? last : first).focus()
      }
    }

    function onEsc(e) { if (e.key === 'Escape') onClose() }

    document.addEventListener('keydown', trapFocus)
    document.addEventListener('keydown', onEsc)
    return () => {
      document.removeEventListener('keydown', trapFocus)
      document.removeEventListener('keydown', onEsc)
    }
  }, [open, onClose])

  return (
    <>
      <div
        className={`tg-scrim${open ? ' is-open' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        ref={panelRef}
        className={`tg-drawer${open ? ' is-open' : ''}`}
        style={{ width }}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="tg-drawer__head">
          <h2 style={{ margin: 0, fontSize: 'var(--tg-text-md)', fontWeight: 'var(--tg-weight-semibold)', color: 'var(--tg-text-primary)' }}>
            {title}
          </h2>
          <button className="tg-icon-btn" onClick={onClose} aria-label="Close">
            <IconX size={20} />
          </button>
        </div>
        <div className="tg-drawer__body">
          {children}
        </div>
      </div>
    </>
  )
}
